import { Navigate } from '../types';

const windowNavigate: Navigate = (url, options) => {
  window?.open(url, options?.target);
};

export { windowNavigate };
